import React from 'react';

import { AboutViewer } from './aboutViewer';

export function AboutController() {
  return <AboutViewer />;
}
